export const couponTimerOptions = [
  {
    label: "1 day",
    value: "23:59:59"
  },
  {
    label: "12 hours",
    value: "12:00:00"
  },
  {
    label: "6 hours",
    value: "06:00:00"
  },
  {
    label: "1 hour",
    value: "01:00:00"
  },
  {
    label: "30 mins",
    value: "00:30:00"
  },
  {
    label: "15 mins",
    value: "00:15:00"
  },
  {
    label: "5 mins",
    value: "00:05:00"
  }
];

export const useTimerUnits = () => {
  let timeUnit = 0;
  const maxTimeUnit = 59;

  const hours = [];
  const minutes = [];
  const seconds = [];

  do {
    const timeUnitString = String(timeUnit).padStart(2, "0");
    if (hours.length < 24) {
      hours.push(timeUnitString);
    }

    minutes.push(timeUnitString);
    seconds.push(timeUnitString);

    timeUnit++;
  } while (timeUnit <= maxTimeUnit);

  return {
    hours,
    minutes,
    seconds
  };
};

export const convertTimeFormat = timeValue =>
  timeValue != null ? String(timeValue).padStart(2, "0") : null;
